<template>
  <div class="step">
    <h3 class="title-step secundari">CREATE A COLLECTION</h3>
    <div class="description-step">
      <div class="instructions i-collect">
        <Icon class="big" icon="fluent:add-24-filled" />
        <p>Add more canvas to create a Pixel Collection</p>
      </div>
      <div class="instructions i-collect">
        <Icon icon="fluent:select-all-on-24-regular" />
        <p>Choose the canvas you want to edit</p>
      </div>
      <div class="instructions i-collect">
        <Icon icon="fluent:delete-24-regular" />
        <p>Doble click to delete the canvas</p>
      </div>
      <div class="instructions i-collect">
        <Icon class="big" icon="fluent:lightbulb-filament-48-regular" />
        <p>Touch each pixel of the grid to light the pixels</p>
      </div>
      <div class="instructions i-collect">
        <Icon icon="fluent:wand-24-regular" />
        <p>Customize each canvas separately</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
export default {
  name: "info-component",
  components: {
    Icon,
  },
};
</script>

<style>
.i-collect .iconify {
  font-size: 20px;
  color: #fff;
}

.i-collect .big {
  font-size: 26px;
}

.i-collect p {
  font-size: 15px;
  line-height: 20px;
  margin: 0px 0px 0px 18px;
}
</style>
